import { stringifyQueryParams } from '@revenuemarket/utils';
import { API } from '~apis/axios/instance';
import { AccountType } from '~models/bank/enum';
import { TransactionsModel } from '~models/transactions';
import { ResponseBaseWithData } from '~types/response';

interface TransactionIdentifier {
  companyId: string;
  transactionId: number;
  accountType: AccountType;
}

export const getTransaction = ({
  companyId,
  transactionId,
  accountType,
}: TransactionIdentifier) => {
  return API.get<ResponseBaseWithData<TransactionsModel.TransactionDetail>>(
    `/api/v2/companies/${companyId}/bank-transactions/detail${stringifyQueryParams({
      transactionId,
      accountTypeCode: accountType,
    })}`,
  );
};
